
export function WhoThisIsFor() {
  const scrollToHowItWorks = () => {
    const element = document.getElementById('how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const benefits = [
    {
      icon: 'ri-plane-line',
      title: 'Travel for work or vacation',
      description: 'Earn income while you\'re away without long-term tenant complications'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Legal secondary suite',
      description: 'Maximize your property\'s earning potential within legal boundaries'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Avoid tenant issues',
      description: 'Short and medium-term stays mean fewer long-term tenant risks'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Get clarity first',
      description: 'Understand what\'s allowed before spending money on licences'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="text-xs font-semibold text-[#882629] uppercase tracking-widest mb-4">
            Built for responsible owners
          </div>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Built for owner occupants, not Airbnb cowboys
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed max-w-3xl mx-auto">
            This service is designed for <strong className="text-[#505A5A]">homeowners who live in their property</strong> and want to earn income the right way. We prioritize compliance, transparency, and long-term sustainability over quick profits.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 bg-[#882629] rounded-xl flex items-center justify-center mb-4">
                <i className={`${benefit.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-[#505A5A] mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-[#505A5A]/70 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-lg text-[#505A5A] font-medium mb-8">
            You are in the right place.
          </p>
          <button 
            onClick={scrollToHowItWorks}
            className="border-2 border-[#882629] text-[#882629] px-8 py-3.5 rounded-full text-base font-medium hover:bg-[#882629] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            See how it works
          </button>
        </div>
      </div>
    </section>
  );
}
